//Wallet Connect
export const SET_WEB3 = "SET_WEB3";
export const WALLET_CONNECT = "WALLET_CONNECT";
export const SET_USER_JWT = "SET_USER_JWT";
export const GET_USERS = "GET_USERS";
